
































import Vue from "vue";
import { Prop, Component } from "vue-property-decorator";
import User from "./User.vue";
import Routes from "./Routes.vue";

@Component({
  name: "nav-bar",
  components: {
    User,
    Routes
  },
})
export default class Navbar extends Vue {
  private drawer = true;
  private mini = false;

  // hideMenu(hide: boolean){
  //   if(this.drawer === false){
  //     console.log('se oculta')
  //     this.drawer = hide
  //   }else{
  //     console.log('se muestra')
  //     this.drawer = hide
  //   }
  // }
    private interval: any = {};
  private value = 0;
  private isHide = false;

  // https://randomuser.me/api/portraits/women/10.jpg
  // https://randomuser.me/api/portraits/men/10.jpg

  hideMenu(){
    this.isHide = true;
    this.$emit('hide')
  }

  beforeDestroy() {
    clearInterval(this.interval);
  }

  mounted() {
    this.interval = setInterval(() => {
      if (this.value === 100) {
        return (this.value = 0);
      }
      this.value += 10;
    }, 1000);
  }
}

